import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "datepicker-value" };
const _hoisted_2 = {
    key: 0,
    class: "datepicker-value__connector"
};
import { ref, watch, inject } from 'vue';
import moment from 'moment';
import { disabledBackwardDatesFromStartDate } from '@/utilities/datepicker';
import { dateFormat } from '@/utilities/constants';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Date',
    setup(__props) {
        const store = useStore();
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const groupType = inject('groupType');
        const { draftCondition, isBetweenOperator, keepFooterLoadingDuringInteraction } = useAudienceManager(isInclude, groupIndex);
        const applyDefaultDatepickerValue = () => {
            const today = moment().format(dateFormat);
            return [today, today];
        };
        const selectedDates = ref(draftCondition.value?.value?.length ? [...draftCondition.value.value].map(String) : applyDefaultDatepickerValue());
        const updateDateValue = () => {
            const newDate = isBetweenOperator.value ? [...selectedDates.value] : [selectedDates.value[0]];
            store.dispatch('audienceManager/updateDraftCondition', {
                groupType,
                groupIndex,
                data: { value: newDate },
            });
        };
        const disabledDate = (time) => {
            return disabledBackwardDatesFromStartDate(time, selectedDates.value[0]);
        };
        watch(() => draftCondition.value?.value, newDate => {
            selectedDates.value = newDate?.length ? [...newDate].map(String) : applyDefaultDatepickerValue();
        }, { deep: true, immediate: true });
        watch(() => selectedDates.value[0], firstDate => {
            selectedDates.value[1] = firstDate;
            updateDateValue();
        });
        return (_ctx, _cache) => {
            const _component_el_date_picker = _resolveComponent("el-date-picker");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_date_picker, {
                    modelValue: selectedDates.value[0],
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((selectedDates.value[0]) = $event)),
                        updateDateValue
                    ],
                    type: "date",
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD",
                    clearable: false,
                    editable: false,
                    onChange: _unref(keepFooterLoadingDuringInteraction),
                    onFocus: _unref(keepFooterLoadingDuringInteraction),
                    onPanelChange: _unref(keepFooterLoadingDuringInteraction)
                }, null, 8, ["modelValue", "onChange", "onFocus", "onPanelChange"]),
                (_unref(isBetweenOperator))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('and')), 1))
                    : _createCommentVNode("", true),
                (_unref(isBetweenOperator))
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 1,
                        modelValue: selectedDates.value[1],
                        "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event) => ((selectedDates.value[1]) = $event)),
                            updateDateValue
                        ],
                        type: "date",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD",
                        clearable: false,
                        "disabled-date": disabledDate,
                        editable: false,
                        onChange: _unref(keepFooterLoadingDuringInteraction),
                        onFocus: _unref(keepFooterLoadingDuringInteraction),
                        onPanelChange: _unref(keepFooterLoadingDuringInteraction)
                    }, null, 8, ["modelValue", "onChange", "onFocus", "onPanelChange"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
